import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from '../../styles/forgotpassword.module.css';
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar';
import loader from "../../images/load.gif";

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    if (!email) {
      setError('Please enter your email address');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return false;
    }
    setError('');
    return true;
  };

  const forgotPassword = async () => {
    const isValidated = validate();
    
    if (isValidated) {
      try {
        setLoading(true);
        setEmailSent(false);
        
        const res = await axios.post('https://chatting-club-backend.onrender.com/api/users/forgot-password', {
          email: email
        });
        
        if (res.data.success) {
          setEmailSent(true);
          toast.success('📧 Reset code sent! Check your email.', {
            position: 'bottom-right',
            theme: 'colored',
            autoClose: 5000
          });
        } else {
          toast.error(res.data.message || 'Failed to send reset instructions', {
            position: 'bottom-right',
            theme: 'colored'
          });
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
        toast.error(errorMessage, {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
    } else {
      toast.error(error, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      forgotPassword();
    }
  };

  const handleReset = () => {
    setEmail('');
    setEmailSent(false);
    setError('');
  };

  return (
    <>
      <div className={styles.forgotContainer}>
        <div className={styles.forgotCard}>
          <div className={styles.iconWrapper}>
            <span className={styles.lockIcon}>🔐</span>
          </div>
          
          <h1 className={styles.forgotTitle}>Reset Password</h1>
          
          {!emailSent ? (
            <>
              <p className={styles.forgotInstruction}>
                Enter your email address and we'll send you a code to reset your password.
              </p>

              <div className={styles.formGroup}>
                <label htmlFor="Email" className={styles.formLabel}>Email Address</label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className={`${styles.formInput} ${error ? styles.inputError : ''}`}
                  placeholder="you@example.com"
                  type="email"
                  id="Email"
                  name="Email"
                  autoFocus
                />
                {error && <p className={styles.errorMessage}>{error}</p>}
              </div>

              {loading ? (
                <button className={`${styles.submitBtn} ${styles.loadingBtn}`} disabled>
                  <img alt="loader" src={loader} width={40} height={40} />
                  <span>Sending...</span>
                </button>
              ) : (
                <button onClick={forgotPassword} className={styles.submitBtn}>
                  Send Reset Code
                </button>
              )}
            </>
          ) : (
            <>
              <div className={styles.successMessage}>
                <div className={styles.successIcon}>✅</div>
                <h3 className={styles.successTitle}>Check Your Email</h3>
                <p className={styles.successText}>
                  We've sent a password reset code to <strong>{email}</strong>.
                  Please check your inbox and spam folder.
                </p>
                <p className={styles.successSubText}>
                  The reset code will expire in 15 minutes.
                </p>
                <button onClick={handleReset} className={styles.resendBtn}>
                  Resend Code
                </button>
              </div>
            </>
          )}

          <div className={styles.backToLogin}>
            <span>Remember your password? </span>
            <button 
              className={styles.backLink} 
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;